import { TemplateCategoryEventInfo } from '@/types/template.types';
import { Get } from '../helpers';

const FetchAllGlobalTemplatesForCategoryFilters = (): Promise<TemplateCategoryEventInfo[]> => {
  return Get({
    path: '/v3/admin/templates-category-filters/global-channel/events',
    useCache: true,
    cacheTtl: 60,
  });
};

export default FetchAllGlobalTemplatesForCategoryFilters;
